import PaginatedList from '@theme/paginated-list';

/**
 * Blog Posts List
 *
 * Extends Horizon's core paginated list functionality
 * for blog/article listings.
 *
 * Pagination, infinite loading, history updates,
 * and section rendering are inherited from PaginatedList.
 */
export default class BlogPostsList extends PaginatedList {}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}